import React, { useEffect, useState } from "react";
import { fadeIn, slideIn, staggerContainer, } from "../utils/motion";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import TruncateText from "../TruncateText";

export default function PaintSection  ({lang,colorBlocks,text}) {
    const [index,setIndex] = useState(0)
   
      
  
const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
  

}, []);

const [more, setMore] = useState(false)
const data = useSelector((state) => state.cart.constants); 
  return (
    <motion.section
     variants={staggerContainer()}
    initial='hidden'
    whileInView='show'
    viewport={{  amount: 0.25 }}
     dir="rtl" 
     className ={`relative bg-[#F4F4F4] mt-[8px]   w-full `}>
     <span className='hash-span' id={'PaintSection'}>
    
    </span>

    <motion.div variants={slideIn('left', '', 0.1, 1)} >
<div style={{backgroundColor:colorBlocks.length > 0 ? colorBlocks[index].color :''}} className={`relative transition-all transition-discrete delay-150 duration-500  h-[250px] xl:h-[450px] lg:h-[400px] md:h-[350px] sm:h-[300px] xs:h-[250px]  w-full`}>


<div className="flex w-full">

<img
          src="../../img/Roof-Pic.png"
          alt="Couch-Sofa"
       width='30%'
       height='auto'
       className="my-10 mx-auto max-w-[400px] min-w-[200px] "


        />

</div>  

 



<div  className="flex w-full">
<div className="w-[47%] flex flex-col self-stretch my-auto text-white pr-10 p-1 ">
  { text&& <>               
<motion.h2 variants={fadeIn('left','',1,0.7)} style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'}  text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]  `} >
{  lang=== 'en' ? 'Paints' :'الطلاء'}
                      </motion.h2>
                      <motion.p variants={fadeIn('left','',1,0.7)} style={{height:`${(width/2)/5}px`,overflowY:'auto',whiteSpace:more?'pre-wrap':''}}  className={`${lang === 'en' ? 'text-left' :'text-right'} text-[8px] xl:text-[20px] lg:text-[16px] md:text-[13px] sm:text-[10px] xs:text-[8px]`} >
                      {    
                  lang=== 'en' ?  
                      
                        
                    data&&data.length ?
                        
                      
                      data&&data[3].value_en?.length > 150 ? 
                          <>
                        {more ? data&&data[3].value_en : TruncateText(data&&data[3].value_en , 150)}
                        <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                        
                        {more ?'Less' : 'More'}
                        
                        </span> 
                        </>
                        :data&&data[3].value_en 
                    
                     :''
    
    
    
                  : 
                    
    
                       data&&data.length ?
                        
                      
                        data&&data[3].value?.length > 150 ? 
                            <>
                          {more ? data&&data[3].value : TruncateText(data&&data[3].value , 150)}
                          <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                          
                      
                          { more ?  'الغاء' : 'المزيد'}
                          </span> 
                          </>
                          :data&&data[3].value 
                      
                       :''
                        }
    
                 
                   
                  
                      </motion.p>
                      </>  
                    } 
                    </div>
</div>


       


         <img
          src="../../img/Couch-Sofa.png"
          alt="Couch-Sofa"
       width='45%'
       height='auto'
       style={{marginBottom:"-9%"}}
       className="absolute drop-shadow-xl bottom-0 left-0 max-w-[650px] min-w-[200px] "


        />

</div>

<div className="w-full h-[180px] bg-[#F4F4F4]  " />
<div dir={lang === 'en' ? 'ltr' :'rtl'} style={{overflowX:width >= 1000 ? 'hidden':'auto'}} className={`${width >= 1200 ? 'w-[55%] absolute right-0  bottom-[12%]  flex  ' : 'mt-[-120px] w-full   flex lg:mt-[-70px] md:mt-[-90px] sm:mt-[-100px] xs:mt-[-120px]  '}  p-1 `} >
  

        <div   dir={lang === 'en' ? 'ltr' :'rtl'}  className={`${width >= 1000 ? '  m-auto  flex  gap-1' : 'm-auto flex flex-nowrap  gap-1'} ` } >
          { colorBlocks.length > 0 ?
            colorBlocks.map((block, i) => (
            <button
            key={i}
            onClick={()=>{setIndex(i)}}
    style={{backgroundColor:block.color}}

      className={`transition-all delay-150 duration-500 flex text-center rounded-xl h-[80px] shadow-[0px_3px_3px_rgba(0,0,0,0.25)] ${index === i ? 'w-[140px] border-[1px] border-white':'w-[80px]'} `}
    >
  
       
      <p dir="ltr" className= {`${index === i? 'opacity-[1]' : 'opacity-[0]'}   transition-all delay-150 duration-500 m-auto text-center text-[18px] font-bold text-white`}>{block.color}</p>
 
  
    </button>
          
          
          )):''}
        </div>

        </div>
       

      
<br/>
</motion.div>
    </motion.section>
  );
};




